export default __webpack_public_path__ + "static/media/512_등록매뉴얼_이미지 복사.2cd6f42d.jpg";